// extracted by mini-css-extract-plugin
export default {"property-tab":"elements_property-tab__vqF4P","aside-bar":"elements_aside-bar__bwIFr","tab":"elements_tab__hT6+6","custom-scrollbar":"elements_custom-scrollbar__9cxHQ"};